import React, { useMemo } from 'react'
import { observer } from 'mobx-react'
import { cartMobx, restaurantConfig } from 'restaurant'
import { storeMobx, decorationMobx, queueOrderingMobx, preOrderingMobx } from '@mobxStore'
import CashierController from 'controllers/cashierController'
import StoreInfoBar from './StoreInfoBar'
import PreOrderButton from '../PreOrderButton'
import EatTypeSwitcher from '../EatTypeSwitcher'
import ServiceRingButton from '../ServiceRingButton'
import './index.scss'

const MenuTop: React.FC = () => {
  const isBuyTogether = !!Config.buyTogetherId
  const { eatTypeEntries } = decorationMobx
  const eatType = cartMobx.info.eatType
  // 是否展示预约时间
  const showPreOrder = restaurantConfig.codeType === 'brand' && eatTypeEntries.length <= 2 && !isBuyTogether
  // 是否展示服务铃
  const showRing = restaurantConfig.codeType === 'table' && storeMobx.info.openSendServiceRing && storeMobx.info.inSale
  // 是否展示切换就餐方式
  const showEatType = eatTypeEntries.length >= 2 && !isBuyTogether && !queueOrderingMobx.inPreQueueOrdering && !preOrderingMobx.checkPreOrder

  const eatTypeEntriesValueArr = useMemo(() => {
    const arr: TEatType[] = eatTypeEntries.map(item => item.value)
    return arr
  }, [eatTypeEntries])
  return (
    <div className='menu-header'>
      <StoreInfoBar />
      {!!showPreOrder && <PreOrderButton type={eatType} />}
      {!!showRing && <ServiceRingButton />}
      {!!showEatType && <EatTypeSwitcher types={eatTypeEntriesValueArr} value={eatType} onChange={(value) => CashierController.switchEatType(value)} />}
    </div>
  )
}

export default observer(MenuTop)
